/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-01-23 09:33:08
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-01-23 09:33:17
 * @ Description:
 */

class EventBus {
  constructor () {
    // 已添加监听的事件映射
    this.listenerMap = {}
  }

  /**
   * 添加事件监听
   * @param {string} eventName 事件名
   * @param {(value?: any) => void} handler 处理函数
   */
  on (eventName, handler) {
    const { listenerMap } = this
    if (listenerMap[eventName]) {
      listenerMap[eventName].push(handler)
    } else {
      listenerMap[eventName] = [handler]
    }
  }

  /**
   * 移除事件监听
   * @param {string} eventName
   * @param {() => void} handler
   */
  off (eventName, handler) {
    const { listenerMap } = this
    if (listenerMap[eventName]) {
      const index = listenerMap[eventName].indexOf(handler)
      if (index >= 0) {
        listenerMap[eventName].splice(index, 1)
      }
    }
  }

  /**
   * 触发事件
   * @param {string} eventName 事件名
   * @param {any} value 触发事件时传入的值
   */
  emit (eventName, value) {
    const { listenerMap } = this
    if (listenerMap[eventName]) {
      listenerMap[eventName].forEach(handler => {
        handler(value)
      })
    }
  }
}

export default new EventBus()
